var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Footer"},[_c('p',[_vm._v("Copyright © 2022 - 2026 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"__blank"}},[_vm._v("鲁ICP备11007633号-4")])])])
}]

export { render, staticRenderFns }